import { render, staticRenderFns } from "./FooterNavigation.vue?vue&type=template&id=229ed51c&"
import script from "./FooterNavigation.vue?vue&type=script&lang=js&"
export * from "./FooterNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports